import React from "react";
import Navbar from "./navbar";
function Header() {
  return (
    <header>
      <Navbar/>
    </header>
  );
}

export default Header;
